import HTTP from "@/plugins/http";
import utils from "@/resources/utils";
import validationStatusCode from "@/resources/validation_status_code";

const getInventories = async (
  token,
  page,
  assign,
  code,
  no_assign,
  email,
  type
) => {
  let urls = `/inventories/?page=${page}`;

  if (assign) urls += `&assign=${assign}`;

  if (code) urls += `&code=${encodeURIComponent(code)}`;

  if (no_assign) urls += `&no_assign=${no_assign}`;

  if (email) urls += `&email=${encodeURIComponent(email)}`;

  if (type) urls += `&type=${type}`;

  return validationStatusCode(
    await HTTP.get(urls, {
      headers: utils.headerAuth(token)
    })
  );
};

const getInventoriesWithoutPagination = async (
  token,
  assign,
  no_assign,
  type,
  vet
) => {
  let urls = "/inventories/without_pagination/";

  if (assign) urls += `${urls.includes("?") ? "&" : "?"}assign=${assign}`;

  if (no_assign)
    urls += `${urls.includes("?") ? "&" : "?"}no_assign=${no_assign}`;

  if (type) urls += `${urls.includes("?") ? "&" : "?"}type=${type}`;

  if (vet) urls += `${urls.includes("?") ? "&" : "?"}vet=${vet}`;

  return validationStatusCode(
    await HTTP.get(urls, {
      headers: utils.headerAuth(token)
    })
  );
};

const getInventory = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/inventories/${id}`, {
      headers: utils.headerAuth(token)
    })
  );

const createInventory = async (inventory, token) =>
  validationStatusCode(
    await HTTP.post("/inventories/", inventory, {
      headers: utils.headerAuth(token)
    })
  );

const updateInventory = async (id, inventory, token) => {
  return validationStatusCode(
    await HTTP.patch(`/inventories/${id}/`, inventory, {
      headers: utils.headerAuth(token)
    })
  );
};

const generateInventory = async (data, token) =>
  validationStatusCode(
    await HTTP.post("/inventories/generate_code/", data, {
      headers: utils.headerAuth(token)
    })
  );

const deleteInventory = async (id, token) =>
  validationStatusCode(
    await HTTP.delete(`/inventories/${id}/`, {
      headers: utils.headerAuth(token)
    })
  );

const downloadInventories = async (date, date_to, token) => {
  let endpoint = `/inventories/download/?date=${date}`;
  if (date_to) endpoint = `${endpoint}&date_to=${date_to}`;

  return validationStatusCode(
    await HTTP.get(endpoint, {
      responseType: "blob",
      headers: utils.headerAuth(token)
    })
  );
};

export default {
  getInventory,
  getInventories,
  createInventory,
  updateInventory,
  deleteInventory,
  generateInventory,
  downloadInventories,
  getInventoriesWithoutPagination
};
